import React from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";
import "./cxo-network-section.m.css";
import SectionLink from "../../atoms/SectionLink/index"

const CXONetworkSection = () => {
  const cdnHost = useSelector((state) => get(state, ["qt", "config", "cdn-image"]));
  const networkImageKey = useSelector((state) => get(state, ["qt", "config", "publisher-attributes","homePageData","networkImageS3key"], {}));
  const networkImageUrl = `https://${cdnHost}/${networkImageKey}`;
  const networkData = [
    {
      title: "Distinguished C-Suite Forums",
      description: "2500+ CXOs actively driving dialogue through curated events, expert-led sessions and focused research"
    },
    {
      title: "Find your niche",
      description: "IMA’s India CEO, CFO, CHRO and CMO Forums bring together top leaders from diverse sectors"
    },
    {
      title: "Policy, Sustainability and CFO NxT Forums",
      description: "Empowering enterprise leaders to drive strategy and execution"
    }
  ];

  return (
    <div styleName="cxo-network-section">
      <div styleName="container">
        <div styleName="header">
          <div styleName="shoulder-tag">
            Exclusive CXO Networks
          </div>
          <h2 styleName="section-heading">
            Connect with your peers, expand your horizons
          </h2>
        </div>

        <div styleName="content">
          <div styleName="text-content">
            {networkData.map((item, index) => (
              <div key={index} styleName="network-item">
                <h3 styleName="item-title">{item.title}</h3>
                <p styleName="item-description">{item.description}</p>
              </div>
            ))}
          </div>

          <div styleName="image-content">
            <img
              src={networkImageUrl}
              alt="CXO Network"
              styleName="network-image"
            />
          </div>
        </div>
        <SectionLink href="/peer-group-forums" noTopPadding>Explore our peer groups</SectionLink>
      </div>
    </div>
  );
};

export { CXONetworkSection };